import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { PackageType } from '@frontend/package/types';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

const ID = 'package-type-select';
export interface PackageTypeSelectProps extends Omit<SelectInputV2Props<PackageType>, 'options'> {
    subset?: string[];
    dispatch?: ThunkDispatch<any, any, Action>;
}

export const PackageTypeSelect = (props: PackageTypeSelectProps) => {
    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            options={Object.values(PackageType).map((c) => ({ label: c.replace(/_/g, ' '), value: c }))}
            label={props.label || 'Package type'}
        />
    );
};
